import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.css']
})
export class MessageBoxDialog {

  message: any[];
  html: string;

  constructor(public dialogRef: MatDialogRef<MessageBoxDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      if (data.html) {
        this.html = data.html;
      } else {
        try {
          this.message = [];
          const jsonError = JSON.parse(data.message);
          for (const key in jsonError) {
            this.message.push ({message : jsonError[key]});
          }
        } catch (e) {
          this.message.push ({message: data.message});
        }
      }
    }
}


// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/message-box/message-box.component.ts